"use client";

import { AnimatePresence, motion } from "framer-motion";

/** A number that rolls in from below whenever it changes. */
export default function Ticker({ value, className }: { value: string; className?: string }) {
  return (
    <span className={className} style={{ display: "inline-grid", overflow: "hidden" }}>
      <AnimatePresence initial={false} mode="popLayout">
        <motion.span
          key={value}
          style={{ gridArea: "1 / 1", fontFamily: "inherit" }}
          initial={{ y: "70%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          exit={{ y: "-70%", opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 0.61, 0.36, 1] }}>
          {value}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
